import Vue from 'vue'
import Router from 'vue-router'

import WoodShopBoard from '@/views/WoodShopBoard'
import WeSayHello from '@/views/WeSayHello'
import SondreGame from '@/views/SondreGame'
import CompTest from '@/views/CompTest'

Vue.use(Router)

function route(path, name, component) {
  return {
    path: path,
    name: name,
    component: component
  }
}

export default new Router({
  mode: 'history',
  
  routes: [
    { path: "/", redirect: "/sales" },
    {
      path: "/sales",
      component: WoodShopBoard,
      alias: ['/deliveries', '/visitors']
    },
    route('/hello', 'WeSayHello', WeSayHello),
    route('/sondregame', 'SondreGame', SondreGame),
    route('/CompTest', 'comptest', CompTest)
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js